
import Vue from 'vue';
import Overlay from '@owc-packages/Overlay/src/Overlay.vue';
import {
  HotspotOverlayData,
  HotspotOverlayMethods,
  HotspotOverlayComputed,
  HotspotOverlayProps,
  HotspotOverlayComponent,
} from './HotspotOverlay';

export default (Vue as HotspotOverlayComponent).extend<
  HotspotOverlayData,
  HotspotOverlayMethods,
  HotspotOverlayComputed,
  HotspotOverlayProps
>({
  name: 'owc-hotspot-overlay',
  components: {
    Overlay,
  },
  props: {
    isDarkMode: {
      type: Boolean,
      required: true,
      default: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    isReActivated: {
      type: Boolean,
    },
  },
  beforeDestroy() {
    this.$emit('overlayClose');
  },
});
